import { Label, Theme } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { createUseStyles } from 'react-jss';

import { LabelFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';

interface Props extends Pick<TFormControlConnectorProps, 'areHintsShown'> {
  control: LabelFormControlViewModel;
}
const useStyles = createUseStyles(({ sizes }: Theme) => ({
  indent: {
    padding: sizes.labeled.padding,
  },
}));

const FormLabelControl: React.FC<Props> = ({ areHintsShown, control }) => {
  const classes = useStyles();
  return (
    <div className={classes.indent}>
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <Label {...(areHintsShown && { hint: control.hint })}>
        {control.label}
      </Label>
    </div>
  );
};

export default FormLabelControl;
